import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const macShiftSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="none">
        <path stroke="currentColor"
              d="M14 7l7.42 6.11a.5.5 0 0 1-.31.89H18.5v7h-9v-7H6.9a.5.5 0 0 1-.32-.89L14 7z"></path>
    </svg>
)

const MacShift: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {macShiftSvg}
    </SvgIcon>
)

export default MacShift